module.exports = __webpack_public_path__ + "static/media/ic_cotizacion_diferido.2b6009e4.svg";